import { useRef, useState } from 'react'
import { PortableText } from '@portabletext/react'
import { portableBlockComponents } from '@/utils/portableText'
import s from './Credits.module.scss'

interface DataProps {
    _type: string;
    _ref: string;
    column: any;
}

interface Credits {
    credits: DataProps | null;
    bua: string | null;
    status: string | null;
    client: string | null;
    location: string | null;
    year: string | null;
}

export default function CreditsOnTopMobileComponent({
    credits,
    bua,
    status,
    client,
    location,
    year
}: Credits) {
    const [openedCredits, setOpenedCredits] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    const toggleCredits = () => setOpenedCredits(prev => !prev);

    return (
        <section className={s.creditsAll}>
            <div

                className={`${s.credits} ${openedCredits ? s.opened : ''}`}

            >
                <div className={s.creditsInner}>

                    <div className={s.topRow}>
                        <div className={s.col}>
                            <p>SEE CREDITS</p>
                        </div>
                        {credits && credits.column.length > 0 && <div className={s.plusMinus} onClick={toggleCredits}>
                            {openedCredits ?
                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0" y1="7.5" x2="23" y2="7.5" stroke="#0A0A0A" />
                                </svg>
                                :
                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="12" y1="0.893433" x2="12" y2="22.1066" stroke="#0A0A0A" />
                                    <line x1="22.1094" y1="12" x2="0.896172" y2="12" stroke="#0A0A0A" />
                                </svg>
                            }
                        </div>}
                    </div>
                    <div ref={contentRef} className={s.collapsibleContent}
                        style={{
                            maxHeight: openedCredits ? `${contentRef.current?.scrollHeight}px` : '0px',
                            transition: 'max-height 0.4s ease',
                            overflow: 'hidden'
                        }}>
                        <div className={s.col}>
                            {location && (
                                <div className={s.row}>
                                    <p>LOCATION</p>
                                    <p>{location}</p>
                                </div>
                            )}
                            {client && (
                                <div className={s.row}>
                                    <p>CLIENT</p>
                                    <p>{client}</p>
                                </div>
                            )}
                            {year && (
                                <div className={s.row}>
                                    <p>YEAR</p>
                                    <p>{year}</p>
                                </div>
                            )}
                            {status && (
                                <div className={s.row}>
                                    <p>STATUS</p>
                                    <p>{status}</p>
                                </div>
                            )}
                            {bua && (
                                <div className={s.row}>
                                    <p>BUA</p>
                                    <p>{bua}</p>
                                </div>
                            )}
                        </div>
                        {credits && credits.column.length > 0 &&
                            credits.column.map((creditList: any, index: number) => (
                                <div key={`column-${index}`} className={s.col}>
                                    {creditList && creditList.credits.length > 0 && creditList.credits.map((credit: any, i: number) => (
                                        <div className={s.row} key={`credit-${index}-${i}`}>
                                            <p>{credit.title && credit.title}</p>
                                            {credit.names && (
                                                <PortableText
                                                    value={credit.names}
                                                    components={portableBlockComponents(credit.names)}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </section>
    );
}